import { APIResponse } from '@src/types/common/api'
import { KolCategory, AddCustomKol } from '@src/types/kol'
import { request } from './request'

export async function addUserCustomizeCategoryUser(
  data: AddCustomKol,
): Promise<APIResponse<string>> {
  return request.post('/agent-kol/user-customize-category-user', data)
}

export async function addUserCustomizeCategory(
  categoryName: string,
): Promise<APIResponse<{ id: number }>> {
  return request.post('/agent-kol/user-customize-category', { categoryName })
}

export async function getAllCategorys(
  agentId: number,
): Promise<APIResponse<{ predictCategory: KolCategory[]; userCustomizeCategory: KolCategory[] }>> {
  return request.get(`/agent-kol/all-category`, { params: { agentId } })
}

export async function deleteUserCustomizeCategoryUser(
  categoryId: number,
): Promise<APIResponse<string>> {
  return request.delete(`/agent-kol/user-customize-category-user/${categoryId}`)
}

export async function deleteUserCustomizeCategory(id: number): Promise<APIResponse<string>> {
  return request.delete(`/agent-kol/user-customize-category/${id}`)
}

export async function editUserCustomizeCategory(
  id: number,
  categoryName: string,
): Promise<APIResponse<string>> {
  return request.put(`/agent-kol/user-customize-category/${id}`, { categoryName })
}

export async function deleteBatchKol(data: {
  agentId: number
  ids: number[]
}): Promise<APIResponse<string>> {
  return request.delete(`/agent-kol/batch`, { data })
}
